import { useModel as _useModel, defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
import { DICT_TYPE, getIntDictOptions } from '@/utils/dict';
import { reactive, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'BasicInfo',
  props: {
    "modelValue": {},
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, {
    expose: __expose
  }) {
    const modelData = _useModel(__props, "modelValue");
    const formRef = ref(); // 表单 Ref
    const formRules = reactive({
      code: [{
        required: true,
        message: '流程标识不能为空',
        trigger: 'blur'
      }],
      name: [{
        required: true,
        message: '流程名称不能为空',
        trigger: 'blur'
      }],
      status: [{
        required: true,
        message: '状态不能为空',
        trigger: 'change'
      }]
    });
    /** 表单校验 */
    const validate = async () => {
      await formRef.value?.validate();
    };
    __expose({
      validate
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createBlock(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: modelData.value,
        rules: formRules,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "流程标识",
              prop: "code"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: modelData.value.code,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => modelData.value.code = $event),
                placeholder: "请输入流程标识"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "流程名称",
              prop: "name"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: modelData.value.name,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => modelData.value.name = $event),
                placeholder: "请输入流程名称"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "状态",
              prop: "status"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: modelData.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => modelData.value.status = $event),
                placeholder: "请选择状态"
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getIntDictOptions)(_unref(DICT_TYPE).COMMON_STATUS), dict => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    key: dict.value,
                    label: dict.label,
                    value: dict.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: modelData.value.remark,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => modelData.value.remark = $event),
                rows: 2,
                type: "textarea",
                placeholder: "请输入备注"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"]);
    };
  }
});